module.exports = __webpack_public_path__ + "static/media/lil-nugl.2832e7ed.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/lil-nugl.png
// module id = 830
// module chunks = 0